import { jsx, Fragment } from 'react/jsx-runtime';
import { CompositionBlock } from './CompositionBlock.js';
import { compatibleVersions } from '../../constants.js';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import 'react';
import '@contentful/experiences-core/constants';
import '@contentful/experiences-core';

const PreviewDeliveryRoot = ({ locale, experience }) => {
    const { entityStore } = experience;
    const { resolveDesignValue } = useBreakpoints(entityStore?.breakpoints ?? []);
    if (!entityStore?.experienceEntryFields || !entityStore?.schemaVersion) {
        return null;
    }
    if (!compatibleVersions.includes(entityStore.schemaVersion)) {
        console.warn(`[experiences-sdk-react] Contentful experience schema version: ${entityStore.schemaVersion} does not match the compatible schema versions: ${compatibleVersions}. Aborting.`);
        return null;
    }
    return (jsx(Fragment, { children: entityStore.experienceEntryFields.componentTree.children.map((childNode, index) => (jsx(CompositionBlock, { node: childNode, hyperlinkPattern: experience.hyperlinkPattern, locale: locale, entityStore: entityStore, resolveDesignValue: resolveDesignValue }, index))) }));
};

export { PreviewDeliveryRoot };
//# sourceMappingURL=PreviewDeliveryRoot.js.map
